import { DEFAULT_ENERGY_PANEL } from "./lib/constants";
import { buildEstimatedFields } from "./lib/auto-generate-fields";

const initialState = {
    isDirty: false,
    panel: { ...DEFAULT_ENERGY_PANEL },
};

const reducer = (state, action) => {
    switch (action.type) {
        case "UPDATE_STATE":
            let estimatedValues = {};

            if (action.key === "ranges") {
                // Re map estimated Costs
                estimatedValues = buildEstimatedFields(action.value);
            }

            const updatedPanel = {
                ...state.panel,
                [action.key]: action.value,
                ...estimatedValues,
            };

            return {
                ...state,
                isDirty: true,
                panel: updatedPanel,
            };
        case "SAVE_PANEL":
            return {
                ...state,
                isDirty: action.isDirty,
                panel: action.panel,
            };
        case "SET_DIRTY_FLAG":
            return {
                ...state,
                isDirty: action.isDirty,
            };
        default:
            return state;
    }
};

export { reducer, initialState };
